/* eslint-disable react/no-unescaped-entities */
import { Box, Button, Typography } from '@mui/material'
import React from 'react'

import { useLoginScreenStyle } from '../hooks/useLoginScreenStyleHook'
import { useTranslation } from 'react-i18next'

const SingUpMenu = () => {
    const { t: translate } = useTranslation()
    const { underLineButtonStyle, colorButtonStyle, subtitle2Style } =
        useLoginScreenStyle()

    const containerStyle = {
        marginTop: { xs: '10px', md: '-60px' },
        display: { xs: 'none', md: 'flex' },
        minWidth: '220px',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        position: 'relative',
        left: '70px',
    }
    return (
        <Box sx={containerStyle}>
            <Typography sx={subtitle2Style}>
                {translate('dontHaveAccountQuestion')}
            </Typography>
            <Button sx={colorButtonStyle}>
                {translate('signUpButtonText')}
            </Button>
            <Button sx={underLineButtonStyle} disableRipple>
                {translate('continueAsGuestButtonText')}
            </Button>
        </Box>
    )
}

export default SingUpMenu
